/**
 * @callback Map
 * @param {string} value
 * @param {number} line
 * @param {boolean} blank
 * @returns {string}
 */
var eol = /\r?\n|\r/g;
/**
 * @param {string} value
 * @param {Map} map
 * @returns {string}
 */

export function indentLines(value, map) {
  /** @type {Array.<string>} */
  var result = [];
  var start = 0;
  var line = 0;
  /** @type {RegExpExecArray|null} */

  var match;

  while (match = eol.exec(value)) {
    one(value.slice(start, match.index));
    result.push(match[0]);
    start = match.index + match[0].length;
    line++;
  }

  one(value.slice(start));
  return result.join('');
  /**
   * @param {string} value
   */

  function one(value) {
    result.push(map(value, line, !value));
  }
}